<template>
    <div>
        <!-- 图片 -->
         <div class="box" v-if="file.type=='jpg'||file.type=='png'||file.type=='jpeg'">
            <img v-if="clsoe" @click.stop="reuploadClick" class="close" src="@/assets/BidDetails/icon-close.png">
            <el-image style="width: 120px;height: 120px;" fit="none" :src="file.filePath"  :preview-src-list="[file.filePath]"></el-image>
            <div style="margin-left: 10px;line-height: 20px;">
                <div style="font-size: 14px;color: #606266;margin: 5px 0 10px 0;width: 170px;" class="single-line">{{ file.fileName }}</div>
                <div style="color: #999999;font-size: 12px;">{{ bytesToSize(file.fileSize?file.fileSize:0) }}</div>
                <div style="color: #999999;font-size: 12px;margin: 10px 0;">{{ file.createTime }}</div>
            </div>
        </div>
        <!-- pdf -->
        <div v-else class="box" @click="handleViewFile(file.filePath,file.fileName)">
            <img v-if="clsoe" @click.stop="reuploadClick" class="close" src="@/assets/BidDetails/icon-close.png">
            <div>
                <img style="width: 40px;height: 40px;" v-if="file.type=='pdf'" :src="require('@/assets/BidDetails/icon-pdf.png')">
                <img style="width: 40px;height: 40px;" v-else-if="file.type=='doc'||file.type=='docx'" :src="require('@/assets/BidDetails/icon-doc.png')">
                <img style="width: 40px;height: 40px;" v-else-if="file.type=='ppt'" :src="require('@/assets/BidDetails/icon-ppt.png')">
                <img style="width: 40px;height: 40px;" v-else-if="file.type=='xls'||file.type=='xlsx'" :src="require('@/assets/BidDetails/icon-xls.png')">
                <img style="width: 40px;height: 40px;" v-else-if="file.type=='zip'||file.type=='rar'" :src="require('@/assets/BidDetails/icon-zip.png')">
                <img style="width: 40px;height: 40px;" v-else :src="require('@/assets/BidDetails/other.png')">
            </div>
            <div style="margin-left: 10px;">
                <div style="font-size: 14px;color: #606266;width: 230px;" class="single-line">{{ file.fileName }}</div>
                <div style="color: #999999;font-size: 12px;">{{ bytesToSize(file.fileSize?file.fileSize:0) }}</div>
            </div>
        </div>
    </div>
</template>
    
<script>
    import{ bytesToSize} from '@/utils/sczn.js'
    export default {
        data(){
            return{
                bytesToSize
            }
        },
        props:{
            //
            file: {
                type: Object,
                default:{}
            },
            // 父级字段名称
            listName:{
                type:String,
                default:''
            },
            // 是否可以删除
            clsoe:{
                type:Boolean,
                default:false
            }
        },
        watch: {
            file: {
                immediate: true,
                handler(val) {
                    this.file.type=this.file.fileName.split(".").pop()
                }
            }
           
        },
        methods:{
            handleViewFile(filePath,fileName){
                 // 附件查看与下载
                const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
                if (ext == 'pdf' || 'PDF') {
                    window.open(filePath, "_blank");
                } else {
                    const eLink = document.createElement("a");
                    eLink.download = fileName;
                    eLink.style.display = "none";
                    eLink.href = filePath;
                    document.body.appendChild(eLink);
                    eLink.click();
                    eLink.remove()
                }
            },
            reuploadClick(){
                if(this.$parent.reuploadClick){
                    this.$parent.reuploadClick(this.listName)
                }else if(this.$parent.$parent.reuploadClick){
                    this.$parent.$parent.reuploadClick(this.listName)
                }else if(this.$parent.$parent.$parent.$parent.reuploadClick){
                    this.$parent.$parent.$parent.$parent.reuploadClick(this.listName)
                } else{
                    this.$parent.$parent.$parent.reuploadClick(this.listName)
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .box{
        width: 300px;
        background: #F2F6FC;
        border-radius: 2px;
        padding: 10px;
        position: relative;
        display: flex;
        cursor: pointer;
    }
    .close{
        position: absolute;
        right: -8px;
        top: -8px;
        cursor: pointer;
    }

</style>
   